import React from "react";
import "./section-heading.scss";

const SectionHeading = ({ title, showAll, navigate, recommendedSellers, categoryParam }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-heading-container-kl">
            <div className="section-heading-title-kl">
              {title}
            </div>
            {showAll && <button onClick={() => {
              navigate(`/top-grocery-stores`, {
                state: {
                  recommendedSellers: recommendedSellers,
                  categoryParam: categoryParam
                },
              });
            }} className="view-all-btn-kl">View All</button>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionHeading;
